exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link_gewest_title {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n}\r\n\r\n.link_vk {\r\n    text-align: center;\r\n}\r\n\r\n.link_vk > article {\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.link_cat {\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n}\r\n\r\n.link_links {\r\n    margin-left: 20px;\r\n    font-size: 16px;\r\n}\r\n.link_links > li > a{\r\n    color: black;\r\n}\r\n\r\n@media screen and (min-width:768px) {\r\n#vk{\r\n    margin-top: 35px;\r\n}\r\n}\r\n\r\n@media screen and (max-width:767px) {\r\n\r\n    .smaller {\r\n        font-size: 24px;\r\n    }\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/links.css
// module id = 58
// module chunks = 0